import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  selectQueryParams,
  changeQueryParams,
  selectItemById,
  selectItemsIds,
  selectRequestState,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

import { selectReferrer } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

const listReduceName = 'usersModule.lists.publicUsersList';

export default function createContainer(ChildContainer) {
  class PublicSearchUsersListContainer extends Component {
    handleSendRequest() {
      this.props.sendRequest();
    }

    render() {
      return <ChildContainer {...this.props} />;
    }
  }
  PublicSearchUsersListContainer.propTypes = {
    // CONNECT DISPATCH
    changeQueryParams: PropTypes.func.isRequired,
    sendRequest: PropTypes.func.isRequired
  };

  const mapStateToProps = state => ({
    auntUserReferrer: selectReferrer(state),
    requestState: selectRequestState(state, listReduceName),
    itemsIds: selectItemsIds(state, listReduceName),
    selectItemById: id => selectItemById(state, listReduceName, id),
    selectQueryParams: selectQueryParams(state, listReduceName)
  });

  const mapDispatchToProps = dispatch => ({
    changeQueryParams: queryParams =>
      dispatch(changeQueryParams(listReduceName, queryParams)),
    sendRequest: () => dispatch(sendRequest(listReduceName))
  });
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(PublicSearchUsersListContainer);
}



// WEBPACK FOOTER //
// ./src/components/Users/containers/PublicSearchUsersListContainer/PublicSearchUsersListContainer.js